import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingServicedeskRequestResolverRoute: InvariantJiraRoute = {
	name: 'project-setting-servicedesk-request-resolver',
	path: '/jira/servicedesk/projects/:projectKey/settings/ai-agents/request-resolver',
	exact: true,
};
